import BaseClass from './Base.class'

export default class Applet extends BaseClass {
  async trigger () {
    this._dependencies.$injector.get('objectManagerService').callMethod('triggerApplet', { applet: this.member.uuid }, { notificationsSuccess: this._notifications.success, notificationsError: this._notifications.error })
  }
}
